import apiClient from '../apiClient';
import { GET_EXCURSION_LIST_URL } from '../apiUrl';

const getExcursionListApi = () => {
  return apiClient.get(GET_EXCURSION_LIST_URL);
};

export default getExcursionListApi;
